// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";

// Components Imports
import { Button, Label, Input } from "../../revvComponents";
import LZLoader from "../LZLoader";

class ConfirmationBoxV2 extends Component {
  state = {
    confirm: false,
  };

  _toggleCheckbox = () => {
    this.setState(prevState => ({ confirm: !prevState.confirm }));
  };

  _onClose = () => {
    this.setState({ confirm: false });
    this.props.closePopup();
  };

  _onConfirmation = data => {
    const { confirmAction } = this.props;
    this.setState({ confirm: false });
    confirmAction(data);
  };

  render() {
    const {
      data,
      header,
      okBtnText,
      subHeader,
      checkboxLabel,
      cancelBtnText,
      loaderMessage,
      showBtnLoader,
    } = this.props;
    return (
      <div className="quote-deletepopup">
        <Modal open onClose={this._onClose} closeOnOverlayClick={false} center>
          {showBtnLoader && (
            <LZLoader className="loader-bg-color" label={loaderMessage} />
          )}
          <div
            className="modal-container"
            data-test="confirmationboxv2-container">
            <div
              className="modal-heading"
              data-test="confirmationboxv2-main-heading">
              {header}
            </div>
            <div
              className="modal-subheading"
              data-test="confirmationboxv2-main-subheading">
              {subHeader}
            </div>
            <div
              className="confirmationboxv2-form"
              data-test="confirmationboxv2-checkbox-wrapper">
              <Input
                id="confirmationboxv2-checkbox-input"
                data-test="confirmationboxv2-checkbox-input"
                type="checkbox"
                value=""
                checked={this.state.confirm}
                onChange={() => this._toggleCheckbox()}
              />
              <Label
                htmlFor="confirmationboxv2-checkbox-input"
                data-test="confirmationboxv2-checkbox-label-wrapper">
                <span
                  className="confirmationboxv2-checkbox-label"
                  data-test="confirmationboxv2-delete-checkbox-label">
                  {checkboxLabel}
                </span>
              </Label>
            </div>

            <div className="modal-footer">
              <Button
                className="btn btn-transparent modal-footer-btn cancle-btn"
                data-test="assetitemrenamepopup-cancle-btn"
                onClick={this._onClose}>
                {cancelBtnText || "No, I do not want to"}
              </Button>
              <Button
                className="btn modal-footer-btn reject-document"
                data-test="assetitemrenamepopup-submit-btn"
                disabled={!this.state.confirm}
                onClick={() => this._onConfirmation(data)}
                isLoading={showBtnLoader}>
                {okBtnText || "CONFIRM"}
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ConfirmationBoxV2;
